export const darkTheme = {
    bg:"#1C1C27",
    bgLight: "#dde810",
    primary:"#ede432",
    text_primary:"#ff0505",
    text_secondary:"#b1b2b3",
    card:"#171721",
    card_light: '#191924',
    button:"#cff705",
    white:"#FFFFFF",
    black:"#000000",
}

export const lightTheme = {
    bg:"#FFFFFF",
    bgLight: "#f0f0f0",
    primary:"#ede432",
    text_primary:"#111111",
    text_secondary:"#48494a",
    card:"#FFFFFF",
    button:"#5c5b5b",
}